import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { ApplicationService } from '../../service/application.service';
import { CompanyService } from '../../service/company.service';
import { RevalidationService } from '../../service/revalidation.service';
import Alert from '../common/Alert';

import '../../../node_modules/ag-grid-community/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/styles/ag-theme-alpine.css';

const NewRevalidation = (params) => {
    const [companies, setCompanies] = useState([]);
    const [applications, setApplications] = useState([]);
    const [months, setMonths] = useState([]);

    const [revDate, setRevDate] = useState(new Date().toISOString().split('T')[0]);
    const [revRepeat, setRevRepeat] = useState(1);
    const [revCompany, setRevCompany] = useState([]);
    const [revApplication, setRevApplication] = useState([]);

    const [message, setMessage] = useState([]);
    const [isAlert, setIsAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [invokeCallBack, setInvokeCallBack] = useState(false);

    const companyService = new CompanyService();
    const applicationService = new ApplicationService();
    const revalidationService = new RevalidationService();

    useEffect(() => {
        const fetchData = async () => {
            const rsCompany = await companyService.getCompanyOnly();
            let dataCompany = rsCompany.data.map(function (a) {
                return { value: a.id, label: (a.name) };
            });
            setCompanies(dataCompany);

            const resApp = await applicationService.getApplications();
            let dataApp = resApp.data.map(function (a) {
                return { value: a.id, label: (a.name) };
            });
            setApplications(dataApp);

            setMonths([
                { value: 1, label: "1" },
                { value: 2, label: "2" },
                { value: 3, label: "3" },
                { value: 4, label: "4" },
                { value: 5, label: "5" },
                { value: 6, label: "6" },
                { value: 7, label: "7" },
                { value: 8, label: "8" },
                { value: 9, label: "9" },
                { value: 10, label: "10" },
                { value: 11, label: "11" },
                { value: 12, label: "12" }
            ]);

            try {
                const revData = await revalidationService.getRevalidationDetailsById(params.id);
                if (revData.data) {
                    setRevDate(new Date(revData.data.scheduleDate).toISOString().split('T')[0]);
                    if (revData.data.repeatIn) {
                        setRevRepeat({ value: revData.data.repeatIn, label: revData.data.repeatIn.toString() });
                    };
                    if (revData.data.companies) {
                        setRevCompany(revData.data.companies.map((x) => { return { value: x.id, label: x.name } }));
                    }
                    if (revData.data.applications) {
                        setRevApplication(revData.data.applications.map((x) => { return { value: x.id, label: x.name } }));
                    }
                }
            }
            catch (err) {
                console.log(err);
            }
        }

        fetchData()
            .catch(console.error);
    }, []);

    const checkValidation = () => {
        let result = true;
        let newMessage = [];

        if (!revApplication || revApplication.length === 0 || revApplication.length === undefined) {
            newMessage.push({ id: 1, text: "No application is selected" });
            result = false;
        }

        if (!revCompany || revCompany.length === 0 || revCompany.length === undefined) {
            newMessage.push({ id: 2, text: "No company is selected" });
            result = false;
        }

        if (!revDate || revDate === undefined) {
            newMessage.push({ id: 3, text: "No scheduled date is selected" });
            result = false;
        }

        setMessage(newMessage);
        return result;
    };

    const saveRevalidation = async () => {
        if (checkValidation() === true) {
            const userRevalidation = {
                id: params.id,
                scheduleDate: revDate,
                repeatIn: revRepeat ? revRepeat.value : 0,
                companies: revCompany,
                applications: revApplication
            }

            let saveResult = await revalidationService.saveRevalidationSetup(userRevalidation);
            if (saveResult.status === 200) {
                setAlertMessage(saveResult.data.message);
                if (saveResult.data.isSuccess === true) {
                    setInvokeCallBack(true);
                }
                alertOn(true);
            }
            else {
                setAlertMessage(saveResult.data.message);
                alertOn(true);
            }
        }
    };

    const removeMessage = (id) => {
        if (message.length > 0) {
            let newMessage = message.filter((m) => {
                return (m.id !== id);
            });
            setMessage(newMessage);
        }
    };

    const alertOff = () => {
        setIsAlert(false);

        if (invokeCallBack === true) {
            if (params.callBack != undefined) {
                params.callBack();
            }
            setInvokeCallBack(false);
            params.onClose();
        };
    }

    const alertOn = () => {
        setIsAlert(true);
    };

    return (
        <>
            {isAlert && <div><Alert type="error" message={alertMessage} callBack={alertOff} /></div>}

            <div className="card" style={{ width: "760px", margin: "auto" }}>
                <h5 className="card-header py-3">
                    <i className="fa fa-folder-open-o" aria-hidden="true"></i> New Revalidation
                </h5>
                <div className="card-body">
                    <div>
                        {(message.length > 0) ?
                            <ul>
                                {message.map(m =>
                                    <li style={{ color: "red" }} key={m.id}>{m.text}</li>
                                )}
                            </ul>
                            : ""}
                    </div>
                    <div className="ag-theme-alpine" style={{ height: "375px", overflowY: "auto" }}>
                        <div style={{ width: "700px" }}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div style={{ backgroundColor: "lightgray", borderRadius: "10px", padding: "15px" }}>
                                        You can schedule a revalidation process to validate the users by their supervisors.
                                        It can set by Application or by Company or by both. When the revalidation starts the users and
                                        supervisors will be notified. Then they will be notified 2 more times before the user gets
                                        deactivated. Manager has to approve/reject the users in the meantime. Individual users can
                                        change their Manager anytime during this period. The revalidation workflow will restart for
                                        that user then.
                                    </div>
                                </div>
                            </div>

                            <div className="row" style={{ marginTop: "10px" }}>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Application List</label>
                                        <Select isMulti options={applications} value={revApplication} onChange={(e) => { setRevApplication(e); removeMessage(1); }} />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Company List</label>
                                        <Select isMulti options={companies} value={revCompany} onChange={(e) => { setRevCompany(e); removeMessage(2); }} />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Date</label>
                                        <input className="form-control" type="date" selected={revDate} value={revDate} onChange={(e) => { setRevDate(e.target.value); removeMessage(3); }} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Repeats In Months</label>
                                        <Select options={months} value={revRepeat} onChange={(e) => setRevRepeat(e)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
                <div className="card-footer text-muted">
                    <div style={{ textAlign: "center" }}>
                        <button onClick={saveRevalidation} className="btn btn-secondary" style={{ marginRight: "5px" }}>Save</button>
                        <button className="btn btn-secondary" onClick={params.onClose}>Close</button>
                    </div>
                </div>
            </div >
        </>
    );
};

export default NewRevalidation;
